var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 76,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 74.667,
  height: 32,
  x: 0.667,
  fill: "var(--hop-neutral-surface-strong)",
  rx: 8.057
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-text-strong)",
  d: "M45.009 18.407v-1.633h.223l2.645-2.837h1.602l-3.042 3.259h-.23zm-1.24 2.265v-8.976h1.336v8.976h-1.337Zm4.24 0-2.38-3.175.922-.946 3.109 4.12h-1.651Zm-10.337-3.988v3.988h-1.338v-6.735h1.277l.013 1.65h-.133q.29-.903.85-1.319t1.355-.416q.686 0 1.199.29.518.289.8.855.29.56.29 1.398v4.277h-1.337v-4.109q0-.729-.38-1.138-.373-.41-1.03-.41-.445 0-.801.199a1.4 1.4 0 0 0-.56.566q-.205.367-.205.904m-4.458 3.988v-6.735h1.337v6.735zm.675-7.76a.83.83 0 0 1-.585-.228.75.75 0 0 1-.247-.56q0-.332.247-.56a.82.82 0 0 1 .585-.236q.349 0 .596.235.247.23.247.56a.75.75 0 0 1-.247.56.85.85 0 0 1-.596.23Zm-7.549 7.76v-8.976h1.392v7.783h4.054v1.193h-5.445Z"
})));
export default SvgLinkButton;